// extracted by mini-css-extract-plugin
export var externalLink = "_dm-0";
export var internalLinkLabel = "_dm-1";